import { ReactNode } from 'react';

import { Box, Stack, SwipeableDrawerProps } from '@mui/material';

import { useInterfaceLanguage } from '@/shared/i18n';

import { NavigationItem, type NavigationItemProps } from '../NavigationItem';
import { SList, SSwipeableDrawer } from './styled';

type MobileNavigationProps = {
  bottomNavigation: NavigationItemProps[];
  children?: ReactNode;
  mainNavigation: NavigationItemProps[];
  profileContainer?: ReactNode;
  promoNavItems?: NavigationItemProps[];
  topNavigation?: ReactNode;
} & SwipeableDrawerProps;

export const MobileNavigation = ({
  bottomNavigation,
  children,
  mainNavigation,
  profileContainer,
  promoNavItems,
  topNavigation,
  ...props
}: MobileNavigationProps) => {
  const { t } = useInterfaceLanguage();

  return (
    <SSwipeableDrawer anchor="bottom" {...props}>
      <SList aria-label={t('common.navigationSidebar')} as="nav">
        {profileContainer && <Box mb={8}>{profileContainer}</Box>}

        {topNavigation && <Stack margin="0 0 16px">{topNavigation}</Stack>}

        {mainNavigation.map(({ title, icon, isDisabled, path, rightText, onClick }) => (
          <NavigationItem
            key={title}
            title={title}
            data-testid="mobile-navigation-item"
            icon={icon}
            isDisabled={isDisabled}
            path={path}
            rightText={rightText}
            isMobile
            onClick={onClick}
          />
        ))}

        {promoNavItems &&
          promoNavItems.length > 0 &&
          promoNavItems.map(({ title, dataTestId, icon, isOutlined, path, rightText, tag, onClick }) => (
            <NavigationItem
              key={title}
              title={title}
              data-testid="mobile-navigation-item-2"
              dataTestId={dataTestId}
              icon={icon}
              isOutlined={isOutlined}
              path={path}
              rightText={rightText}
              tag={tag}
              isMobile
              onClick={onClick}
            />
          ))}

        {bottomNavigation && bottomNavigation.length > 0 && (
          <Stack direction="row" gap={8} mb={-4}>
            {bottomNavigation.map(({ title, dataTestId, icon, onClick }) => (
              <NavigationItem
                key={title}
                title={title}
                data-testid={dataTestId}
                icon={icon}
                isMobile
                onClick={onClick}
              />
            ))}
          </Stack>
        )}

        {children}
      </SList>
    </SSwipeableDrawer>
  );
};
